import React from "react";
import styles from '../../styles/educationFair.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "../CustomImage";
interface Props {
  data: any;
}

const EduFairWhyAttend: React.FC<Props> = ({ data }) => {
  return (

    <div id="why-attend" className={styles.whyattend} style={{ backgroundColor: data?.sectionBgColor || '#ffffff' }}>
      <Container>
        <div className={styles.maindiv}>
          <Row>
            <div className={styles.heading}>
              <h2>{data?.sectionTitle}</h2>
            </div>
          </Row>
          <Row className={styles.contentDiv}>
            {
              data?.pointImage?.length > 0 &&
              data?.pointImage.map((point: any, index: any) => {
                return (
                  <Col xl={6} lg={6} md={6} sm={12} xs={6}>
                    <div className={styles.mainBox}>
                      <div className={styles.box}>
                        <div className={styles.img}>
                          <CustomImage src={point?.imageUrl} width={30} height={30} className={styles.studImg} alt="handshake.png" />
                        </div>
                        <div className={styles.para}>
                          <p>{point?.title}</p>
                        </div>
                      </div>
                    </div>
                  </Col>
                )
              })
            }
          </Row>
        </div>
      </Container>
    </div>
  )
}
export default EduFairWhyAttend;